import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Input,
  Table,
  Button,
  Empty,
  Popover,
  Typography,
} from "antd";
import { EyeOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useFormDocumentacionTecnica } from "../../../../hooks/useFormDocumentacionTecnica";
import { RootState } from "../../../../redux/reducers";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalEditarDocumentosTecnicos } from "./components/ModalEditarDocumentosTecnicos";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { Navegador } from "../../../../components/Administrador/NavegadorConvocatoria/Navegador";
import { useNavigate } from "react-router-dom";
import { useMaestras } from "../../../../hooks/useMaestras";
import { ModalEliminarDocumentosTecnicos } from "./components/ModalEliminarDocumentosTecnicos";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import DocumentInput from "../../../../utils/DocumentInput";
import ModalWarning from "../../../../utils/Alerts/ModalWarning";
import ModalError from "../../../../utils/Alerts/ModalError";
export const DocumentosTecnicos = () => {
  const {
    cargarDocumentosTecnicos,
    documento,
    setDocumento,
    documentos,
    setDocumentos,
    agregarfila,
    eliminarFila,
    guardarArchivo,
    guardarycontinuar,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisulizar,
    modaleditardocumento,
    setModalEditarDocumento,
    indexdocumento,
    setIndexDocumento,
    fileInputRef,
    setGuardoArchivo,
    modaleliminar,
    setModaleliminar,
    indexDocumentacion,
    setIndexDocumentacion,
    nombreDocumento,
    setNombreDocumento,
    loading,
  } = useFormDocumentacionTecnica();
  const { obtenerDocTec, documentosTecnicos } = useMaestras();
  useEffect(() => {
    cargarDocumentosTecnicos();
    obtenerDocTec();
  }, []);
  // const { idConvocatoria } = useSelector(
  //   (state: RootState) => state.convocatoria
  // );
  const { decrypt } = useEncrypt();
  const [modal_war, setModal_war] = useState(false);
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const { Title, Text } = Typography;
  const { TextArea } = Input;
  const { Option } = Select;
  const navigate = useNavigate();

  const fields = [
    { name: "tipo_documento", value: documento.tipo_documento },
    { name: "descripcion", value: documento.descripcion },
    { name: "url_documento", value: documento.url_documento },
    { name: "activo", value: documento.activo },
  ];
  const columns: any = [
    {
      title: "N°",
      width: 100,
      render: (data: any, data2: any, index: number) => {
        return (
          <span className="font-family-Montserrat-Regular">{index + 1}</span>
        );
      },
    },
    {
      title: "Tipo requisito",
      dataIndex: "tipo_documento",
      key: "tipo_documento",
      width: 200,
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
      width: 200,
      render: (datos: any) => {
        return datos.length > 27 ? (
          <Popover content={datos} title="Descripción">
            {`${datos.substring(0, 24)}...`}
          </Popover>
        ) : (
          datos
        );
      },
    },
    {
      title: (
        <div className="row">
          <div className="col-12 justify-content-center">Acciones</div>
          <div className="col-4 font-size-10px font-color-B0B0B0 justify-content-center">
            Ver
          </div>
          <div className="col-4 font-size-10px font-color-B0B0B0 justify-content-center">
            Editar
          </div>
          <div className="col-4 font-size-10px font-color-B0B0B0 justify-content-center">
            Eliminar
          </div>
        </div>
      ),
      width: 200,
      render: (datos: any, datos2: any, index: number) => (
        <div className="row">
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <EyeOutlined
                  onClick={() => {
                    if (datos.url_documento !== "") {
                      setDocumentoVisulizar(datos.url_documento);
                      setModalVisualizarDocumento(true);
                    } else {
                      setModal_war(true);
                    }
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <EditOutlined
                  onClick={() => {
                    setIndexDocumento(index);
                    setModalEditarDocumento(true);
                    setDocumento(datos);
                  }}
                />
              }
            ></Button>
          </div>
          <div className="col-4">
            <Button
              className="button-gray-ghost no-margin"
              icon={
                <DeleteOutlined
                  onClick={() => {
                    setIndexDocumentacion(index);
                    setNombreDocumento(datos.url_documento);
                    return setModaleliminar(true);
                  }}
                />
              }
            ></Button>
          </div>
        </div>
      ),
    },
  ];

  const routes = [{ nombre: "Crear convocatoria" }];

  const onAceptar = () => {
    return setModal_war(false);
  };

  return (
    <>
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <Navegador idconvocatorias={idConvocatoria} activo="Doc. Técnica" />
        <div className="container-fluid background-color-F7FBFF ps-md-4 pe-md-4 main-c3">
          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Documentos técnicos
          </div>
          <div>
            <div className="sombra_card" style={{ marginBottom: "20px" }}>
              <div className="header_card">
                <div className="title_in_card">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-12 col-lg-8 font-size-14px font-family-Montserrat-Regular">
                        Asociar documentación técnica
                      </div>
                      <div className="col-12 col-lg-4 d-flex justify-content-lg-end font-size-12px font-color-B0B0B0 font-family-Montserrat-Regular">
                        Código convocatoria {idConvocatoria}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="body_card">
                <div className="row">
                  <Form
                    layout="vertical"
                    size="large"
                    className="row"
                    onFinish={agregarfila}
                    fields={fields}
                    onFieldsChange={(_, fields: any) => {
                      let infoupdate: any = { ...documento };
                      for (var i in fields) {
                        infoupdate[fields[i].name] = fields[i].value;
                      }
                      setDocumento(infoupdate);
                    }}
                  >
                    <div className="col-12 col-md-6">
                      <div>
                        <Form.Item
                          label="Requisito"
                          name="tipo_documento"
                          rules={[
                            { required: true, message: "Campo obligatorio" },
                          ]}
                        >
                          <Select placeholder="Seleccionar...">
                            {documentosTecnicos.map(({ id, nombre }: any) => (
                              <Option key={id} value={nombre}>
                                {nombre}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 mt-2">
                      <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                        Adjuntar un archivo
                      </span>
                      <DocumentInput
                        doc={documento.url_documento}
                        fileInputRef={fileInputRef}
                        tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                        setGuardoArchivo={setGuardoArchivo}
                        on_change={(e) => {
                          setGuardoArchivo(true);
                          guardarArchivo(e);
                          e.target.value = "";
                        }}
                        onDelete={async () => {
                          return setDocumento({
                            ...documento,
                            url_documento: "",
                          });
                        }}
                      />
                      {/* <div className="input-group">
                        <div className="form-control">
                          {documento.url_documento && (
                            <Tag
                              className="font-family-Montserrat-Regular mt-1"
                              closable={true}
                              onClose={async () => {
                                await DocumentosService.eliminarArchivo(
                                  documento.url_documento
                                );
                                setGuardoArchivo(false);
                                return setDocumento({
                                  ...documento,
                                  url_documento: "",
                                });

                              }}
                              onClick={() => {

                              }}
                            >
                              {documento.url_documento.length > 27 ? `${documento.url_documento.split(".")[0].substring(0, 24)}.${documento.url_documento.split(".")[1]}` : documento.url_documento}

                            </Tag>
                          )}
                        </div>
                        <Button className="buttonblanco-radius-input" style={{ width: "20%", borderRadius: '6px' }} onClick={() => {
                          if (fileInputRef.current !== null) {
                            fileInputRef.current.click();
                          }
                        }}
                        >
                          Adjuntar
                        </Button>
                      </div>
                      <div className="font-size-10px font-color-#707070 font-family-Montserrat-Regular">Tipo de archivo: PDF, DOCX, XLSX, JPG, PNG. Máx: 5MB.</div>
                      <input
                        ref={fileInputRef}
                        type="file"
                        hidden
                        onChange={(e) => {
                          setGuardoArchivo(true);
                          guardarArchivo(e);
                          e.target.value = "";
                        }}
                      /> */}
                    </div>
                    <div className="col-12 col-md-12">
                      <Form.Item
                        label="Descripción"
                        name="descripcion"
                        rules={[
                          { required: true, message: "Campo obligatorio" },
                        ]}
                      >
                        <TextArea showCount maxLength={250} />
                      </Form.Item>
                    </div>
                    <div className="col-12">
                      <Button
                        className="button-azul-radius  float-end"
                        htmlType="submit"
                      >
                        Agregar
                      </Button>
                    </div>
                    <div>
                      <div className="col-12">
                        <Table
                          style={{ borderTop: "1px solid #C4C4C4" }}
                          dataSource={documentos}
                          columns={columns}
                          size="small"
                          locale={{
                            emptyText: (
                              <Empty
                                description="No se han diligenciados datos para está sección"
                                style={{ padding: "50px" }}
                              />
                            ),
                          }}
                          rowClassName="sizeTable table-row"
                          pagination={{ hideOnSinglePage: true }}
                          bordered={false}
                        />
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-sticky-footer d-flex justify-content-between align-items-center">
          <div>
            <Button
              className="button-blanco-radius font-size-12px justify-content-flex-start"
              style={{ marginLeft: "16px" }}
              onClick={() => navigate("/administrador/documentos")}
            >
              Atrás
            </Button>
          </div>
          <div className="justify-content-flex-end">
            <Button
              className="button-azul-radius font-size-12px"
              onClick={guardarycontinuar}
              disabled={loading}
            >
              Guardar y Continuar
              {loading && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: 12, marginLeft: 4, color: "#fff" }}
                />
              )}
            </Button>
          </div>
        </div>
        <ModalVisualizarDocumentos
          visualizar={modalvisualizardocumento}
          setVisualizar={setModalVisualizarDocumento}
          state={{ documento: documentovisualizar }}
        />
        <ModalEliminarDocumentosTecnicos
          nombre={nombreDocumento}
          modal={modaleliminar}
          cancelar={() => setModaleliminar(false)}
          indexDocumentacion={indexDocumentacion}
          eliminar={() => eliminarFila(indexDocumentacion)}
        />
        <ModalEditarDocumentosTecnicos
          visualizar={modaleditardocumento}
          setVisualizar={setModalEditarDocumento}
          documento={documento}
          setDocumento={setDocumento}
          documentos={documentos}
          setDocumentos={setDocumentos}
          indexdocumento={indexdocumento}
        />
        <ModalWarning
          visualizar={modal_war}
          setVisualizar={setModal_war}
          onAceptar={onAceptar}
          titlle="Visualización de documento"
          description="Sin documento Adjunto"
          subdescription="Este registro no contiene un documento adjunto."
        />
      </div>
    </>
  );
};
